const style = {
    pageBorder: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    },
    clearButton: {
        margin: "20px"
    }
}

export default style;